module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  })]), _vm._v(" "), _c('img', {
    staticClass: "topbar",
    attrs: {
      "src": "media/global/topbar.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-logo",
    attrs: {
      "src": "media/global/logo.png"
    }
  }), _vm._v(" "), _c('section1')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f8e678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 130
// module chunks = 0